export enum cardTypes {
  empty = "empty",
  create = "create",
  add = "add",
  full = "full",
}
